import { addTimestampToFileName, convertDateToDateOnlyString } from '@/core/utils/datetime';
import { blobResponseHandler, downloadBlob } from '@/shared/helpers/api';
import { baseApi } from '@/admin/baseApi';
import { t } from '@/core/localization';
export const api = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getSuppliersDebt: builder.query({
            query: ({ reportDate, supplierIds }) => ({
                method: 'POST',
                url: 'supplier/payment-balance/debt-report',
                body: {
                    reportDate: convertDateToDateOnlyString(reportDate),
                    supplierIds,
                },
            }),
        }),
        exportSupplierDebtReportToExcel: builder.mutation({
            queryFn: async ({ reportDate, supplierIds }, api, extraOptions, baseQuery) => downloadBlob({
                queryResult: await baseQuery({
                    method: 'POST',
                    cache: 'no-cache',
                    url: 'supplier/payment-balance/debt-report/excel',
                    body: {
                        reportDate: convertDateToDateOnlyString(reportDate),
                        supplierIds,
                    },
                    responseHandler: blobResponseHandler,
                }),
                fileName: `${t('file.name.supplier.debt.report')} ${addTimestampToFileName()}.xlsx`,
            }),
        }),
    }),
});
export const { useGetSuppliersDebtQuery, useExportSupplierDebtReportToExcelMutation } = api;
export { api as supplierDebtReportApi };
